export enum CampaignEnum {
  Garba = "Garba",
  InstaAdDemo = "InstaAdDemo",
}

export const CAMPAIGN_LABEL: Record<CampaignEnum, string> = {
  [CampaignEnum.Garba]: "Garba",
  [CampaignEnum.InstaAdDemo]: "Insta Ad Demo",
};

/** An alert email goes out each time the total scans cross another multiple of this (backend constant). */
export const CAMPAIGN_SCAN_MILESTONE_STEP = 1000;

export interface CampaignSummary {
  name: CampaignEnum;
  scanCount: number;
  scanSourceCount: Record<string, number>;
  lastScanMilestone: number;
  likeCount: number;
  dislikeCount: number;
  entryCount: number;
  shareCount: number;
  blockedEntryCount: number;
}

export interface CampaignEntry {
  _id: string;
  campaign: CampaignEnum;
  name: string;
  phoneNumber?: string;
  entryNumber: string;
  source?: string;
  visitorId?: string;
  /** Whatever extra details the campaign page sent; shown as columns. */
  detail?: Record<string, string | number | boolean>;
  /** A booked time, e.g. a demo slot (UTC ISO string). */
  slot?: string;
  createdAt: string;
}
